(function () {
  'use strict';

  let observer;
  let isLoading = false;
  let currentSection = null;

  function init() {
    // Tear down any existing observer (filter changes re-run this)
    if (observer) {
      observer.disconnect();
      observer = null;
    }

    currentSection = document.querySelector('[data-section-type="collection"]');
    if (!currentSection) return;

    const productList = currentSection.querySelector('.CollectionInner__Products .ProductList');
    const pagination = currentSection.querySelector('.CollectionInner__Products .Pagination');
    if (!productList || !pagination) return;

    // Find next page URL from pagination
    const nextLink = pagination.querySelector('a[rel="next"], .Pagination__NavItem--next, a[href*="page="]:last-of-type');
    const nextUrl = findNextPageUrl(pagination);

    if (!nextUrl) {
      // No more pages — hide pagination entirely
      pagination.style.display = 'none';
      return;
    }

    // Hide pagination visually but keep in DOM as fallback
    pagination.classList.add('Pagination--infinite');

    // Create a sentinel element to observe
    let sentinel = currentSection.querySelector('.InfiniteScrollSentinel');
    if (!sentinel) {
      sentinel = document.createElement('div');
      sentinel.className = 'InfiniteScrollSentinel';
      sentinel.setAttribute('aria-hidden', 'true');
      pagination.parentNode.insertBefore(sentinel, pagination);
    }

    // Store next URL on the section itself so we can update it across loads
    currentSection.dataset.nextPageUrl = nextUrl;

    observer = new IntersectionObserver(onIntersect, {
      rootMargin: '600px 0px', // start loading 600px before sentinel hits viewport
      threshold: 0
    });
    observer.observe(sentinel);
  }

  function findNextPageUrl(paginationEl) {
    // Try rel="next" first (most reliable)
    const relNext = paginationEl.querySelector('a[rel="next"]');
    if (relNext) return relNext.getAttribute('href');

    // Fall back: find the "next" arrow button
    const nextBtn = paginationEl.querySelector('.Pagination__NavItem--next, [aria-label*="next" i], [aria-label*="Next" i]');
    if (nextBtn && nextBtn.tagName === 'A') return nextBtn.getAttribute('href');

    // Last resort: find currently-active page and grab the link after it
    const active = paginationEl.querySelector('.Pagination__NavItem.is-active, [aria-current="page"]');
    if (active && active.nextElementSibling && active.nextElementSibling.tagName === 'A') {
      return active.nextElementSibling.getAttribute('href');
    }

    return null;
  }

  function onIntersect(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting && !isLoading) {
        loadNext();
      }
    });
  }

  function loadNext() {
    if (!currentSection || !currentSection.dataset.nextPageUrl) return;

    isLoading = true;
    showLoader();

    const sectionId = currentSection.getAttribute('data-section-id');
    const url = new URL(currentSection.dataset.nextPageUrl, location.origin);
    url.searchParams.set('section_id', sectionId);

    fetch(url.toString())
      .then((r) => {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      })
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');

        // Append new product cells (skip the banner cell on page 2+)
        const newCells = doc.querySelectorAll('.CollectionInner__Products .ProductList .Grid__Cell');
        const existingList = currentSection.querySelector('.CollectionInner__Products .ProductList');

        if (existingList && newCells.length) {
          newCells.forEach((cell) => {
            // Skip banner cells if they somehow got rendered
            if (cell.querySelector('.Banner')) return;
            existingList.appendChild(cell);
          });
        }

        // Update next URL from the freshly loaded page
        const newPagination = doc.querySelector('.CollectionInner__Products .Pagination');
        const nextUrl = newPagination ? findNextPageUrl(newPagination) : null;

        if (nextUrl) {
          currentSection.dataset.nextPageUrl = nextUrl;
        } else {
          // No more pages — kill the observer
          delete currentSection.dataset.nextPageUrl;
          if (observer) {
            observer.disconnect();
            observer = null;
          }
          const sentinel = currentSection.querySelector('.InfiniteScrollSentinel');
          if (sentinel) sentinel.remove();
        }

        // Force lazysizes to scan new images
        if (window.lazySizes && window.lazySizes.autoSizer) {
          window.lazySizes.autoSizer.checkElems();
        }

        // Notify color swatch handler about new products
        document.dispatchEvent(new CustomEvent('collection:items-added', { bubbles: true }));
      })
      .catch((err) => {
        console.error('Infinite scroll failed:', err);
        // On failure, fall back to showing pagination
        const pagination = currentSection.querySelector('.Pagination');
        if (pagination) {
          pagination.classList.remove('Pagination--infinite');
          pagination.style.display = '';
        }
        if (observer) observer.disconnect();
      })
      .finally(() => {
        isLoading = false;
        hideLoader();
      });
  }

  function showLoader() {
    let loader = currentSection.querySelector('.InfiniteScrollLoader');
    if (!loader) {
      loader = document.createElement('div');
      loader.className = 'InfiniteScrollLoader';
      loader.innerHTML = '<div class="InfiniteScrollLoader__Spinner"></div>';
      const sentinel = currentSection.querySelector('.InfiniteScrollSentinel');
      if (sentinel) sentinel.parentNode.insertBefore(loader, sentinel);
    }
    loader.style.display = 'flex';
  }

  function hideLoader() {
    const loader = currentSection.querySelector('.InfiniteScrollLoader');
    if (loader) loader.style.display = 'none';
  }

  // Initialize on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init when filters change — theme.js dispatches `theme:loading:end` after _reloadProducts
  // We listen for that and re-bind the observer to the new pagination
  let reinitTimeout;
  document.addEventListener('theme:loading:end', function () {
    clearTimeout(reinitTimeout);
    reinitTimeout = setTimeout(init, 100); // small delay to let DOM settle
  });

  // Also re-init on Shopify theme editor section reload
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.querySelector('[data-section-type="collection"]')) {
      setTimeout(init, 100);
    }
  });
})();